import * as Sentry from '@sentry/react';

const enableSentry = (environment, release, user) => {
    if (environment !== 'production') {
        return;
    }

    Sentry.init({
        dsn: 'https://b28628e190e89e96f85755353fbb0bbb@o4508757152694272.ingest.de.sentry.io/4508757154594896',
        environment: environment,
        release: release,
        integrations: [
            Sentry.browserTracingIntegration({
                // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                tracePropagationTargets: ['localhost', /^https:\/\/training-1eaad\.web\.app/],
            }),
            Sentry.replayIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: 0.05, // Capture 100% of the transactions, reduce in production!
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        // PII Data
        sendDefaultPii: true, // Enabled such that Sentry.setUser will work
    });

    user && Sentry.setUser({ id: user.id, email: user.email });
};

export { enableSentry };
